import { render, staticRenderFns } from "./SincronizarJornadas.vue?vue&type=template&id=0b21d346"
import script from "./SincronizarJornadas.vue?vue&type=script&lang=js"
export * from "./SincronizarJornadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports